import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { addToCompanyAction } from '../redux/slices/addToCompanySlice';

const useAddToCompanyDialog = () => {
    const dispatch = useAppDispatch();
    const addToCompanyDialogState = useAppSelector(
        (state) => state.addToCompanyDialog
    );

    const showDialog = (
        open: boolean,
        companyId: string,
        companyName: string,
        isAdmin: boolean
    ) => {
        dispatch(
            addToCompanyAction.setCompany({
                id: companyId,
                name: companyName,
                isAdmin: isAdmin,
            })
        );
        dispatch(addToCompanyAction.setDialogOpen(open));
    };

    const setSuccess = (success: boolean) => {
        dispatch(addToCompanyAction.setSuccessfulSend(success));
    };

    const closeDialog = () => {
        dispatch(addToCompanyAction.resetStates({ isSuccess: false }));
    };
    const closeWithSuccessDialog = () => {
        dispatch(addToCompanyAction.resetStates({ isSuccess: true }));
        // dispatch(addToCompanyAction.setCompany(null));
        // dispatch(addToCompanyAction.setDialogOpen(false));
        // setSuccess(true);
    };

    return {
        addToCompanyDialogState,
        closeWithSuccessDialog,
        showDialog,
        closeDialog,
        setSuccess,
    };
};

export default useAddToCompanyDialog;
